module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjggNTEyIj4NCjxwYXRoIGQ9Ik02NCAzNjBhNTYgNTYgMCAxIDAgMCAxMTIgNTYgNTYgMCAxIDAgMC0xMTJ6bTAtMTYwYTU2IDU2IDAgMSAwIDAgMTEyIDU2IDU2IDAgMSAwIDAtMTEyek0xMjAgOTZBNTYgNTYgMCAxIDAgOCA5NmE1NiA1NiAwIDEgMCAxMTIgMHoiIGZpbGw9IiM0ZDVjNzYiLz48L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ellipsis-vertical-solid.svg
// module id = y2ZV
// module chunks = 89